<div class="mat-container">
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>
        <div class="header-with-toggle">
          <span>APL Categories</span>
          <div class="toggle-container">
            <span
              class="black"
              [ngClass]="{ selected: sortMode == 'typeOrder' }"
              >123</span
            >
            <mat-slide-toggle
              class="small-toggle"
              color="accent"
              (change)="onSortModeChange($event)"
            ></mat-slide-toggle>
            <span class="black" [ngClass]="{ selected: sortMode == 'alpha' }"
              >A-Z</span
            >
          </div>
        </div>
      </mat-header-cell>

      <mat-cell *matCellDef="let e">
        {{ e.code }}
        <span *ngIf="e.open">
          <mat-icon>arrow_forward_ios</mat-icon>
        </span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="openCategory(row.id)"
      [ngClass]="{ pending: row.status != 1, open: row.open }"
    ></mat-row>
  </mat-table>
</div>
